<template>
  <div class="ts-app-shell_fh">
  <RegistrationQuestionnaire :currentPage="currentPageStep">
    <div class="check-list-form">
      <div class="content-type">
        <span>Intake Information</span>
      </div>
      <el-form
        :model="registrationAnswer"
        @submit.native.prevent="updateRegistrationAnswers"
      >
        <p class="heavy-text">Demographic Information</p>
        <div class="content-item">
          <el-row>
            <div class="mb-2 flex items-center text-sm">
              <label role="text">
                Gender
              </label>
              <el-form-item
                :error="
                  retrieveFieldError(
                    modelState,
                    'DemographicInfo.Gender'
                  )
                "
              >
                <el-radio-group
                  v-model="registrationAnswer.demographicInfo.gender"
                  class="ml-4"
                >
                  <el-radio :label="0" size="large">Female</el-radio>
                  <el-radio :label="1" size="large">Male</el-radio>
                  <el-radio :label="2" size="large">I do not wish to answer</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </el-row>
        </div>
        <div class="content-item" v-if="registrationAnswer.demographicInfo.gender === 1">
          <el-row>
            <el-col :xl="24" :lg="24" :md="24" :sm="24">
              <label role="text">Have you registered with the Selective Service?</label>
              <el-form-item
                :error="
                  retrieveFieldError(
                    modelState,
                    'DemographicInfo.RegisteredWithSelectiveServices'
                  )
                "
              >
                <el-select v-model="registrationAnswer.demographicInfo.registeredWithSelectiveServices" placeholder="Select">
                  <el-option
                    v-for="item in selectedServicesOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <p class="heavy-text">Ethnic Origin</p>
        <div class="content-item">
          <el-row>
            <div class="mb-2 flex items-center text-sm">
              <label role="text">
                Are you of Haitian heritage?
              </label>
              <el-form-item
                :error="
                  retrieveFieldError(
                    modelState,
                    'EthnicOrigin.Haitian'
                  )
                "
              >
                <el-radio-group
                  v-model="registrationAnswer.ethnicOrigin.haitian"
                  class="ml-4"
                >
                  <el-radio :label="0" size="large">Yes</el-radio>
                  <el-radio :label="1" size="large">No</el-radio>
                  <el-radio :label="2" size="large">I do not wish to answer</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </el-row>
        </div>
        <div class="content-item">
          <el-row>
            <div class="mb-2 flex items-center text-sm">
              <label role="text">
                Are you of Hispanic or Latino heritage?
              </label>
              <el-form-item
                :error="
                  retrieveFieldError(
                    modelState,
                    'EthnicOrigin.Hispanic'
                  )
                "
              >
                <el-radio-group
                  v-model="registrationAnswer.ethnicOrigin.hispanic"
                  class="ml-4"
                >
                  <el-radio :label="0" size="large">Yes</el-radio>
                  <el-radio :label="1" size="large">No</el-radio>
                  <el-radio :label="2" size="large">I do not wish to answer</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </el-row>
        </div>
        <p class="heavy-text">Race</p>
        <div class="content-item">
          <el-row>
            <div class="mb-2 flex items-center text-sm">
              <label role="text">
                Please check all that apply:
              </label>
              <el-form-item
                :error="
                  retrieveFieldError(
                    modelState,
                    'Race.RaceSelection'
                  )
                "
              >
                <div style="font-size: 15px !important;">
                  <el-checkbox-group v-model="registrationAnswer.race.raceSelection" >
                    <el-checkbox style="font-size: 15px !important;" label="African American/Black">
                    </el-checkbox>
                    <br/>
                    <el-checkbox style="font-size: 15px !important;" label="Asian">
                    </el-checkbox>
                    <br/>
                    <el-checkbox style="font-size: 15px !important;" label="White">
                    </el-checkbox>
                    <br/>
                    <el-checkbox style="font-size: 15px !important;" label="American Indian/Alaskan Native">
                    </el-checkbox>
                    <br/>
                    <el-checkbox style="font-size: 15px !important;" label="Hawaiian/Other Pacific Islander">
                    </el-checkbox>
                    <br/>
                    <el-checkbox style="font-size: 15px !important;" label="I do not wish to answer">
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
              </el-form-item>
            </div>
          </el-row>
        </div>
        <p class="heavy-text">Language</p>
        <div class="content-item">
          <el-row>
            <div class="mb-2 flex items-center text-sm">
              <label role="text">
                Do you have limited proficiency in speaking, writing, reading, or understanding
                English?
                OR
                Do you have difficulty in speaking, writing, reading or understanding English?
              </label>
              <el-form-item
                :error="
                  retrieveFieldError(
                    modelState,
                    'Language.LimitedProficiencyInEnglish'
                  )
                "
              >
                <el-radio-group
                  v-model="registrationAnswer.language.limitedProficiencyInEnglish"
                  class="ml-4"
                >
                  <el-radio :label="0" size="large">Yes</el-radio>
                  <el-radio :label="1" size="large">No</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </el-row>
        </div>
        <div v-if="registrationAnswer.language.limitedProficiencyInEnglish === 0">
          <div class="content-item">
            <el-row>
              <el-col :xl="24" :lg="24" :md="24" :sm="24">
                <label role="text">Please select your primary language:</label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'Language.PrimaryLanguage'
                    )
                  "
                >
                  <el-select v-model="registrationAnswer.language.primaryLanguage" placeholder="Select">
                    <el-option
                      v-for="item in languageOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <el-col :xl="24" :lg="24" :md="24" :sm="24">
                <label role="text">How well do you speak that language?</label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'Language.PrimacyLanguageProficiency'
                    )
                  "
                >
                  <el-select v-model="registrationAnswer.language.primacyLanguageProficiency" placeholder="Select">
                    <el-option
                      v-for="item in languageProficiencyOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Do you require English Language Assistance?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'Language.RequireEnglishLanguageAssistance'
                    )
                  "
                >
                  <el-radio-group
                    v-model="registrationAnswer.language.requireEnglishLanguageAssistance"
                    class="ml-4"
                  >
                    <el-radio :label="0" size="large">Yes</el-radio>
                    <el-radio :label="1" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <el-col :xl="24" :lg="24" :md="24" :sm="24">
                <label role="text">How well do you speak English?</label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'Language.EnglishProficiency'
                    )
                  "
                >
                  <el-select v-model="registrationAnswer.language.englishProficiency" placeholder="Select">
                    <el-option
                      v-for="item in englishProficiencyOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="content-item action-section">
          <el-row>
            <el-col span="8">
              <el-button
                class="ts-btn ts-btn-outline wioa-btn-outline"
                @click="backToDashboard"
              >
                Previous
              </el-button>
            </el-col>
            <el-col span="8">
              <el-button
                class="ts-btn ts-btn-secondary"
                @click="updateRegistrationAnswers"
              >
                Next
              </el-button>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
  </RegistrationQuestionnaire>
  <TSLoading
      :active="isLoading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process your data...'"
    />
  </div>
</template>

<script>
import RegistrationQuestionnaire from "../../component/RegistrationQuestionnaire.vue";
import TSLoading from "../../../../components/TSLoading.vue";

export default {
  components: { RegistrationQuestionnaire, TSLoading },
  data(){
    return{
      checklist: ['Asian', 'White'],
      modelState: {},
      isLoading: false,
      registrationAnswer: {
        priorityOfService: {},
        militaryService: {},
        veteranInfo: {},
        transitioningServiceMembers: {},
        militaryMemberSpouse: {},
        disability: {},
        householdInfo: {},
        publicAssistance: {},
        demographicInfo: {},
        ethnicOrigin: {},
        race: {
          raceSelection: []
        },
        language: {},
      },
      demographicInfoEmpty: {
        gender: null,
        registeredWithSelectiveServices: null,
      },
      ethnicOriginEmpty: {
        haitian: null,
        hispanic: null,
      },
      raceEmpty: {
        raceSelection: [],
      },
      languageEmpty: {
        limitedProficiencyInEnglish: null,
        primaryLanguage: null,
        primacyLanguageProficiency: null,
        requireEnglishLanguageAssistance: null,
        englishProficiency: null,
      },
      jobSeekerId: null,
      selectedServicesOptions: [{
          value: 0,
          label: 'Yes'
        }, {
          value: 1,
          label: 'No'
        }, {
          value: 2,
          label: 'Not Applicable'
        }],
      languageOptions: [
        {
          value: 'American Sign Language',
          label: 'American Sign Language'
        },
        {
          value: 'Amharic',
          label: 'Amharic'
        },
        {
          value: 'Apache',
label: 'Apache'
        },
        {
          value: 'Arabic',
label: 'Arabic'
        },
        {
          value: 'Bengali',
label: 'Bengali'
        },
        {
          value: 'Bosnian',
label: 'Bosnian'
        },
        {
          value: 'Chinese',
label: 'Chinese'
        },
        {
          value: 'French',
label: 'French'
        },
        {
          value: 'German',
label: 'German'
        },
        {
          value: 'Greek',
label: 'Greek'
        },
        {
          value: 'Haitian Creole',
label: 'Haitian Creole'
        },
        {
          value: 'Hawaiin',
label: 'Hawaiin'
        },
        {
          value: 'Hebrew',
label: 'Hebrew'
        },
        {
          value: 'Hindi',
label: 'Hindi'
        },
        {
          value: 'Hopi',
label: 'Hopi'
        },
        {
          value: 'Italian',
label: 'Italian'
        },
        {
          value: 'Japanese',
label: 'Japanese'
        },
        {
          value: 'Korean',
label: 'Korean'
        },
        {
          value: 'Latin',
label: 'Latin'
        },
        {
          value: 'Malay',
label: 'Malay'
        },
        {
          value: 'Navajo',
label: 'Navajo'
        },
        {
          value: 'Persian',
label: 'Persian'
        },
        {
          value: 'Polish',
label: 'Polish'
        },
        {
          value: 'Portuguese',
label: 'Portuguese'
        },
        {
          value: 'Pueblo',
label: 'Pueblo'
        },
        {
          value: 'Russian',
label: 'Russian'
        },
        {
          value: 'Somali',
label: 'Somali'
        },
        {
          value: 'Spanish',
label: 'Spanish'
        },  
        {
          value: 'Tagalog',
label: 'Tagalog'
        },
        {
          value: 'Tewa',
label: 'Tewa'
        },  
        {
          value: 'Thai',
label: 'Thai'
        },
        {
          value: 'Tiwa',
label: 'Tiwa'
        },  
        {
          value: 'Towa',
label: 'Towa'
        },
        {
          value: 'Turkish',
label: 'Turkish'
        },  
        {
          value: 'Urdu',
label: 'Urdu'
        },
        {
          value: 'Vietnamese',
label: 'Vietnamese'
        },  
        {
          value: 'Yiddish',
label: 'Yiddish'
        },  
        {
          value: 'Zuni',
          label: 'Zuni'
        },
        {
          value: 'Other',
label: 'Other'
        },
        ],
      languageProficiencyOptions: [{
          value: 'Very Well',
          label: 'Very Well'
        }, {
          value: 'Well',
          label: 'Well'
        }, {
          value: 'Not Well',
          label: 'Not Well'
        }, {
          value: 'Not at All',
          label: 'Not at All'
        }],
      englishProficiencyOptions: [{
          value: 'Fluently',
          label: 'Fluently'
        }, {
          value: 'I speak and understand well enough to communicate',
          label: 'I speak and understand well enough to communicate'
        }, {
          value: 'I require an interpreter',
          label: 'I require an interpreter'
        }],
    }
  },
  computed: {
    currentPageStep() {
      return this.$route.meta.currentPage;
    },
  },
  created() {
    window.scrollTo(0,0);
    this.isLoading = true;
    this.jobSeekerId = this.$store.state.account.applicant_user_info.jobSeekerId;
    this.$store
      .dispatch("jobseeker/getRegistrationAnswerByJobSeekerId", this.jobSeekerId)
      .then((res) => {
        if (res === null || res === undefined || res.priorityOfService === null) {
          this.$router.push({ name: "RegistrationQuestionnaireOne" });
        } else {
          this.registrationAnswer = res;

          this.registrationAnswer.demographicInfo = this.registrationAnswer.demographicInfo === null 
            ? this.demographicInfoEmpty 
            : this.registrationAnswer.demographicInfo;
          this.registrationAnswer.ethnicOrigin = this.registrationAnswer.ethnicOrigin === null 
            ? this.ethnicOriginEmpty 
            : this.registrationAnswer.ethnicOrigin;
          this.registrationAnswer.race = this.registrationAnswer.race === null 
            ? this.raceEmpty 
            : this.registrationAnswer.race;
          this.registrationAnswer.language = this.registrationAnswer.language === null 
            ? this.languageEmpty 
            : this.registrationAnswer.language;
        }
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
  methods: {
    backToDashboard() {
      this.$router.push({ name: "RegistrationQuestionnaireThree" });
    },
    updateRegistrationAnswers() {
      this.isLoading = true;
      this.registrationAnswer.validatePageType = 4;

      if (this.registrationAnswer.demographicInfo.gender !== 1) this.registrationAnswer.demographicInfo.registeredWithSelectiveServices = null;
      if (this.registrationAnswer.language.limitedProficiencyInEnglish !== 0) {
        this.registrationAnswer.language.primaryLanguage = null;
        this.registrationAnswer.language.primacyLanguageProficiency = null;
        this.registrationAnswer.language.requireEnglishLanguageAssistance = null;
        this.registrationAnswer.language.englishProficiency = null;
      }
      this.$store
        .dispatch("jobseeker/updateRegistrationAnswer", this.registrationAnswer)
        .then(res => {
          if (res) {
            this.$router.push({ name: "RegistrationQuestionnaireFive" });
          }
        })
        .catch(res => {
          this.modelState = res;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.el-checkbox__label {
  font-size: 15px !important;
}
</style>
